/** Import File Dto. */
export class ImportFileDto {
  constructor(data) {
    this.file = data.file;
    this.group_admin_id = data.group_admin_id;
  }
}
